import { useEffect } from 'react';

export function useScrollReveal() {
  useEffect(() => {
    if (typeof window === 'undefined') return; // SSR safety

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // Trigger if intersecting OR if the element is already above the viewport (scrolled past)
          if (entry.isIntersecting || entry.boundingClientRect.top <= 0) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0,                 // zero-height safe
        rootMargin: '0px 0px -40px 0px',
      }
    );

    // Small delay so DOM/images are fully painted before observing (crucial for routing/back navigation)
    const timer = setTimeout(() => {
      document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));
      document.querySelectorAll('.img-reveal').forEach((el) => observer.observe(el));
    }, 100);

    return () => {
      clearTimeout(timer);
      observer.disconnect();
    };
  }, []);
}